import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { HtmlLike } from "@common/controls/component";
import withValue from "@common/hocs/withValue";
import { Common } from "@common/types";
import classnames from "classnames";
import { identity, isNull } from "lodash";
import * as React from "react";
import OnOff from "../OnOff/component";

export type CheckboxProps = Common.InputTypeProps<boolean> & {
  addon?: any;
  label?: string;
  isDisabled?: boolean;
  htmlValue?: string | string[] | number;
};

const CheckboxBase = (props: CheckboxProps) => (
  <div className="checkbox" onClick={() => !props.isDisabled && props.onChange(!props.value)}>
    <input
      type="checkbox"
      checked={props.value}
      onChange={(_) => _}
      disabled={props.isDisabled}
      value={props.htmlValue}
    />
    {!!props.label && <label style={props.style}>{props.label}</label>}
    {props.addon}
  </div>
);

const Checkbox = withValue<boolean, CheckboxProps>(CheckboxBase);
export default Checkbox;

export type FancyCheckboxNullIndicator = "indeterminated" | "cross";
export type FancyCheckboxProps = Common.InputTypeProps<boolean | null> & {
  children?: any;
  className?: string;
  hasErrors?: boolean;
  htmlValue?: any;
  id?: string;
  image?: any;
  isDisabled?: boolean;
  isLeft?: boolean;
  isRequired?: boolean;
  isThreeState?: boolean;
  label?: any;
  labelClassName?: string;
  nullIndicator?: FancyCheckboxNullIndicator;
  showLabel?: boolean;
  tabIndex?: number;
  tooltip?: string;
  mode?: "default" | "onOff";
};

export class FancyCheckbox extends React.PureComponent<FancyCheckboxProps> {
  public render() {
    if (this.props.mode === "onOff")
      return <OnOff {...this.props} value={this.props.value ?? false} label={this.props.label} />;

    return (
      <div
        id={this.props.id}
        className={classnames(
          "checkbox",
          this.props.className,
          this.props.nullIndicator && isNull(this.props.value) ? this.props.nullIndicator : "",
          {
            disabled: this.props.isDisabled,
            left_label: this.props.isLeft,
            checked: this.props.value
          }
        )}
      >
        <span
          className="img-responsive"
          onClick={this.props.isDisabled ? undefined : this._onClick}
          {...getTooltipAttributes(this.props.tooltip)}
        >
          <input
            disabled={this.props.isDisabled}
            name={this.props.name}
            type="checkbox"
            checked={this.props.value ?? false}
            onChange={identity}
            value={this.props.htmlValue}
            title={this.props.label}
            required={this.props.isRequired}
            tabIndex={this.props.tabIndex}
          />
          <span className="check-wrap">
            <span
              className={classnames("custom_checkbox", {
                has_errors: this.props.hasErrors
              })}
            />
          </span>
          {(this.props.showLabel ?? true) && !!this.props.label && (
            <HtmlLike
              tag="span"
              className={classnames("checkbox_label", this.props.labelClassName)}
              style={this.props.style}
            >
              {this.props.label}
            </HtmlLike>
          )}
          {this.props.image ? (
            typeof this.props.image === "string" ? (
              <img className="img-thumbnail" title={this.props.label} src={this.props.image} />
            ) : (
              this.props.image
            )
          ) : null}
        </span>
      </div>
    );
  }

  private _onClick = () => {
    this.props.onChange &&
      this.props.onChange(
        // checked (-> null) -> unchecked
        this.props.isThreeState
          ? this.props.value
            ? null
            : isNull(this.props.value)
            ? false
            : true
          : !this.props.value
      );
  };
}
